// routes
import { paths } from 'src/routes/paths';
// utils
import apiClient, { refreshTokens } from 'src/utils/api-client';

// ----------------------------------------------------------------------

const ACCESS_KEY = 'access_token';
const REFRESH_KEY = 'refresh_token';
// Refresh a bit before the access token actually expires.
const REFRESH_SKEW_MS = 2 * 60 * 1000;

let refreshTimer;

function jwtDecode(token) {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split('')
      .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
      .join('')
  );

  return JSON.parse(jsonPayload);
}

// ----------------------------------------------------------------------

export const isValidToken = (accessToken) => {

  if (!accessToken) {
    return false;
  }

  const decoded = jwtDecode(accessToken);

  const currentTime = Date.now() / 1000;

  return decoded.exp > currentTime;
};

// ----------------------------------------------------------------------

export const forceLogout = () => {
  clearTimeout(refreshTimer);
  localStorage.removeItem(ACCESS_KEY);
  localStorage.removeItem(REFRESH_KEY);
  delete apiClient.defaults.headers.common.Authorization;
  window.location.href = paths.auth.login;
};

// Auto-renew the short-lived access token in the background so the user stays
// logged in until the (7-day) refresh token itself expires.
const scheduleRefresh = (exp) => {
  clearTimeout(refreshTimer);

  const timeLeft = exp * 1000 - Date.now() - REFRESH_SKEW_MS;

  refreshTimer = setTimeout(async () => {
    const token = await refreshTokens();
    if (token) {
      scheduleRefresh(jwtDecode(token).exp);
    } else {
      forceLogout();
    }
  }, Math.max(timeLeft, 0));
};

// ----------------------------------------------------------------------

export const setSession = (accessToken, refreshToken) => {
  if (accessToken) {
    localStorage.setItem(ACCESS_KEY, accessToken);
    if (refreshToken) {
      localStorage.setItem(REFRESH_KEY, refreshToken);
    }

    apiClient.defaults.headers.common.Authorization = `Bearer ${accessToken}`;

    scheduleRefresh(jwtDecode(accessToken).exp);
  } else {
    clearTimeout(refreshTimer);
    localStorage.removeItem(ACCESS_KEY);
    localStorage.removeItem(REFRESH_KEY);

    delete apiClient.defaults.headers.common.Authorization;
  }
};
